import { types, getParent, getRoot, flow } from 'mobx-state-tree';

const URL = 'account/v1/Accounts';

const Orders = types
  .model('Orders', {
    maximumPurchaseLimit: types.optional(types.number, 0),
    negativeProfitLimit: types.optional(types.number, 0),
    preferUsedLikeNew: types.optional(types.boolean, false),
    shippingPreferenceStatusses: types.optional(types.array(types.string), []),
    preferedShippingStatus: types.optional(types.string, ''),
  })
  .views(self => ({
    get transport5007() {
      return getParent(self).transport5007;
    },
    get accountCode() {
      return getRoot(self).uiStore.sessionStore.accountCode;
    },
    get showToast() {
      return getParent(self, 2).toastsStore.showToast;
    },
    get enums() {
      return getParent(self, 2).enumsStore.getEnumsList;
    },
  }))
  .actions(self => ({
    getShippingPreferenceStatusses: flow(function* getShippingPreferenceStatusses() {
      try {
        const { data } = yield self.transport5007.fetch(
          `account/v1/preferences/listing-preferences`,
        );
        self.shippingPreferenceStatusses = data;
      } catch (err) {
        console.log('getting shipping preference statusses failed: ', err);
      }
    }),
    updateShippingStatus: flow(function* updateShippingStatus(status) {
      try {
        yield self.transport5007.put(`account/v1/preferences/listing-preferences`, { status });
        yield getParent(self).userProfile.fetchUserProfile();
        self.showToast({
          type: self.enums.TOAST_TYPES.INFO,
          message: 'Your shipping preference has been updated!',
        });
      } catch (err) {
        self.showToast({
          type: self.enums.TOAST_TYPES.WARNING,
          message: 'There was an error while updating your shipping preference!',
        });
        console.log('updating shipping preference status failed: ', err);
      }
    }),
    saveOrdersPreferences: flow(function* saveOrdersPreferences() {
      try {
        const payload = [
          {
            op: 'replace',
            path: '/negativeProfitLimit',
            value: self.negativeProfitLimit,
          },
          {
            op: 'replace',
            path: '/maximumPurchaseLimit',
            value: self.maximumPurchaseLimit,
          },
          {
            op: 'replace',
            path: '/preferUsedLikeNew',
            value: self.preferUsedLikeNew,
          },
        ];
        yield self.transport5007.patch(`${URL}/${self.accountCode}`, payload, {}, {});
        yield getParent(self).userProfile.fetchUserProfile();
      } catch (e) {
        console.error(e);
      }
    }),
    setMaximumPurchaseLimit: value => {
      if (!value) {
        self.maximumPurchaseLimit = 0;
      } else if (typeof value === 'string') {
        if (!isNaN(parseFloat(value))) {
          self.maximumPurchaseLimit = parseFloat(value);
        }
      } else if (typeof value === 'number') {
        self.maximumPurchaseLimit = value;
      }
    },
    setNegativeProfitLimit: value => {
      if (!value) {
        self.negativeProfitLimit = 0;
      } else if (typeof value === 'string') {
        if (!isNaN(parseFloat(value))) {
          self.negativeProfitLimit = parseFloat(value);
        }
      } else if (typeof value === 'number') {
        self.negativeProfitLimit = value;
      }
    },
    setPrefferedShippingStatus: value => {
      self.preferedShippingStatus = value;
    },
    setPreferUsedLikeNew: value => {
      self.preferUsedLikeNew = value;
    },
    initConnections: flow(function* initConnections() {
      yield Promise.allSettled([self.getShippingPreferenceStatusses()]);
    }),
  }));

export default Orders;
